<template>
  <v-dialog v-model="dialog"
            persistent
            max-width="400px">
    <v-form @submit.prevent="submit"
            :disabled="form.busy">
      <v-card>
        <v-card-title>
          <v-icon left>
            fas fa-fw fa-upload
          </v-icon>
          Upload Files
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-file-input v-model="form.files"
                        label="Files"
                        multiple
                        chips
                        small-chips
                        :accept="mimeTypes">
          </v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-progress-linear v-if="form.busy"
                             indeterminate>
          </v-progress-linear>
          <template v-else>
            <v-btn type="submit"
                   color="primary"
                   :disabled="form.busy">
              Upload
            </v-btn>
            <v-btn @click.prevent="cancel"
                   text>
              Cancel
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import {Form} from 'vform';
import formValidation from '../../../plugins/formValidation';
import teamAssetService from '../../../../../ml/services/teamAssetService';
import pluralize from 'pluralize';

export default {
  mixins: [formValidation],
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    path: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: new Form({
        files: [],
      }),
    }
  },
  computed: {
    mimeTypes() {
      return teamAssetService.mimeTypes();
    },
  },
  methods: {
    submit() {
      if (this.form.busy) {
        return;
      }
      this.form.busy = true;
      const files = this.form.files;
      return teamAssetService.upload(files, this.path)
          .then(() => {
            //const message = `${pluralize(files, 'file', true)} uploaded.`
            //this.$toast.success(message);
            this.$emit('uploaded');
          })
          .catch(err => {
            console.log(err);
            this.form.errors.set(err.response?.data);
            this.form.busy = false;
          })
    },
    cancel() {
      this.$emit('canceled');
    }
  }
}
</script>
